import { useEffect } from 'react'
export const useUpdateHistory = (c: string, setterFunction: any) => {
  useEffect(() => {
    setterFunction((h: string[]) =>
      h[h.length - 1] === c ? [...h] : [...h, c],
    )
  }, [c, setterFunction])
}
